// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '53b8ff80808f6c4dbadc120ce5dcf981536ded78';
export const BUILD_NUMBER = '239';
export const BUILD_TIMESTAMP = '2026-09-16T03:24:12.255Z';
